import { createFormStoreEvents } from '../create-form-store-events';

export const stockEvents = createFormStoreEvents('stockStore');
